export default __webpack_public_path__ + "static/media/menu1.5eb41e21.jpg";